import { ProductsApi } from "@api/products";
import { useQuery } from "@tanstack/react-query";
import { QUERY_KEYS } from "@common/queryKeys";

const getItemsFromLocalStorage = () => {
  try {
    const storage = localStorage.getItem("enp_cros_storage");
    if (storage) {
      const parsedStorage = JSON.parse(storage);
      return parsedStorage || [];
    }
    return [];
  } catch (error) {
    return [];
  }
};

export const useBrandProductsQuery = ({ pcodeList }) => {
  return useQuery({
    queryKey: QUERY_KEYS.PRODUCTS.BRAND.INDEX(pcodeList),
    queryFn: async () => {
      try {
        // 로컬 스토리지에서 상품 코드 가져오기
        const localItems = getItemsFromLocalStorage();
        // 사용할 아이템 결정 (총 6개가 되도록)
        let items = [];

        if (localItems && localItems.length > 0) {
          // 로컬 스토리지 아이템 추가
          items = [...localItems];

          // 로컬 스토리지 아이템이 6개 미만인 경우 pcodeList에서 추가
          if (items.length < 6 && pcodeList && pcodeList.length > 0) {
            // 필요한 추가 아이템 수 계산
            const remainingCount = 6 - items.length;
            // pcodeList에서 필요한 만큼만 가져와서 추가
            const additionalItems = pcodeList.slice(0, remainingCount);
            items = [...items, ...additionalItems];
          }
        } else if (pcodeList && pcodeList.length > 0) {
          // 로컬 스토리지 아이템이 없는 경우 pcodeList 사용
          items = pcodeList.slice(0, 6); // 최대 6개까지만 사용
        }

        // 혹시 6개를 초과하는 경우 6개로 자르기
        if (items.length > 6) {
          items = items.slice(0, 6);
        }

        const body = {
          modes: "SetProductView",
          items: items,
        };

        // API 호출 시도
        const res = await ProductsApi(body);

        if (res?.Code === "0000" && res?.Data?.Data) {
          return res.Data.Data;
        } else if (res?.Data) {
          return res.Data;
        }

        return []; // 데이터가 없는 경우 빈 배열 반환
      } catch (error) {
        console.error("API 호출 중 오류 발생:", error);

        return [];
      }
    },
    enabled: !!pcodeList?.length,
    onError: (error) => {
      console.error("Query 오류:", error);
    },
    onSuccess: (data) => {
      console.log("Query 성공, 데이터:", data);
    },
    refetchOnWindowFocus: false,
  });
};
